let idCounter = 0;
export class UndoRedoAction {
    constructor() {
        Object.defineProperty(this, "internalName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = idCounter++;
    }
    get name() {
        return this.internalName;
    }
    set name(name) {
        this.internalName = name;
    }
    run() {
        return;
    }
    undo() {
        return;
    }
    redo() {
        this.run();
    }
    destroy() {
        return;
    }
}
export class LazyUndoRedoAction extends UndoRedoAction {
    queued() {
        return;
    }
}
